import { Hero } from '../hero';
import { CohortForm } from '../cohort-form';
import { useParams } from 'react-router-dom';
import { Cohort, CohortByIdQuery, CohortByIdQueryVariables, FETCH_COHORT_BY_ID } from '@edwin-group/cj-graphql';
import { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useAssessmentStore } from '../../store/useAssessmentStore';
import { LoadingContainer } from '../../../shared/components/loading-container';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';

export const CohortFormScreen = () => {
  const { cohortDocumentId } = useParams<{ cohortDocumentId?: string }>();
  const setCohortToUpdate = useAssessmentStore((state) => state.setCohortToUpdate);
  const [fetchCohortById, { loading }] = useLazyQuery<CohortByIdQuery, CohortByIdQueryVariables>(FETCH_COHORT_BY_ID, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    (async () => {
      if (cohortDocumentId) {
        const cohort = await fetchCohortById({ variables: { documentId: cohortDocumentId } });
        setCohortToUpdate(cohort.data?.cohort as Cohort);
        return;
      }

      setCohortToUpdate(null);
    })();
  }, [cohortDocumentId, fetchCohortById, setCohortToUpdate]);

  const title = cohortDocumentId ? 'Update Cohort' : 'Create Cohort';

  if (loading) {
    return (
      <Container className="!mt-sh-60">
        <div className="col-span-12 lg:col-start-3 lg:col-end-11">
          <PageHeader title={title} type="none" />
          <LoadingContainer title="Loading cohort..." />
        </div>
      </Container>
    );
  }

  return (
    <Container className="!mt-sh-60">
      <div className="col-span-12 lg:col-start-3 lg:col-end-11">
        <PageHeader title={title} type="none" />
        <div className="mt-5 pb-10">
          <Hero />
          <CohortForm />
        </div>
      </div>
    </Container>
  );
};
